import { RootAppState } from 'store/configureStore'

/** @deprecated Feature removed - statusChangeInPortalIsAllowed no longer exists on ProjectRow */
export const projectStatusChangeInPortalAllowedSelector = (
  _state: RootAppState,
) => {
  return undefined
}
